import { FireFlashsaleColored, FlashSaleFilled } from '@teko/ds-icon';
import {
  BaseProps,
  Caption,
  CommonStyles,
  Row,
  ThemeProps,
  styled,
} from '@teko/ds-mobile';
import { CountdownTime } from '@teko/teko-ecommerce';
import desktopBackground from 'assets/nl-desktop-flash-sale-background.svg';
import mobileBackground from 'assets/nl-mobile-flashsale-background.svg';
import { useTenantConfig } from 'hooks';
import { t } from 'i18n';
import React from 'react';
import { ProgressBar } from './ProgressBar';

interface WrapperProps extends ThemeProps, BaseProps {
  background: string;
}

export interface FlashSalePromotionProps extends ThemeProps, BaseProps {
  progress: number;
  message?: string;
  endAt?: string | number | Date;
}

export const FlashSalePromotion: React.FC<FlashSalePromotionProps> = ({
  endAt,
  message,
  progress,
  ...rest
}: FlashSalePromotionProps) => {
  const { isMobile } = useTenantConfig();

  return (
    <Wrapper
      background={isMobile ? mobileBackground : desktopBackground}
      {...rest}
    >
      <Row align="middle" justify="space-between" margin={['s4', 's0']}>
        <>
          <FlashSaleFilled size={24} color="#FFA940" />
          <StyledCaption weight="bold" color="white" marginLeft="s4">
            Flashsale
          </StyledCaption>
        </>
        {endAt && (
          <Row align="baseline">
            <Caption weight="regular" color="white" level={1}>
              {t('Kết thúc sau')}
              {': '}
            </Caption>
            <StyledCountDownTime
              level={2}
              endAt={
                typeof endAt === 'string' || typeof endAt === 'number'
                  ? new Date(endAt)
                  : endAt
              }
              weight="bold"
              marginLeft="s4"
            />
          </Row>
        )}
      </Row>
      <Row>
        <ProgressBar
          barHeight={24}
          progress={progress}
          barColor="#FA700C26"
          backgroundColor="white"
          justify={progress === 100 ? 'center' : 'start'}
          barContent={
            <Row
              marginLeft="s4"
              align="middle"
              style={{ zIndex: 100, textTransform: 'uppercase' }}
            >
              <FireFlashsaleColored size={20} z={2} />
              <Caption
                level={1}
                weight="medium"
                color="#FA541C"
                marginLeft="s4"
              >
                {message}
              </Caption>
            </Row>
          }
        />
      </Row>
    </Wrapper>
  );
};

const Wrapper = styled.div<WrapperProps>(
  ({ background, theme }: WrapperProps) => `
    background: url("${background}");
    padding: ${theme?.spacing.s4} ${theme?.spacing.s8};
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
`,
  CommonStyles,
  'border-radius: 10px;',
);

const StyledCaption = styled(Caption)`
  text-transform: uppercase;
  flex: 1 0 auto;
  font-size: 15px;
`;

const StyledCountDownTime = styled(CountdownTime)`
  font-size: 15px;
`;
